export default __webpack_public_path__ + "c562ac329a53859b5cfe19675f08cecf.png";